import { faFilePdf, faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";

//STYLES
import { Action } from "./style"

//COMPONENTS
import { Switcher } from "../../../../../../Components/CustomUi/Switcher";
import ButtonCustom from "../../../../../../Components/ButtonCustom";
import ReactToPrint from 'react-to-print';
import { useAccess } from "../../../../../../context/useAccess";
import { GeracaoCanceladaError, gerarPdfDoBook } from "../../../../../../utils/gerarPdfBook";
import { errorAlert, infoAlert, successAlert } from "../../../../../../utils/alert";
import { LoadingPdf } from "../../../../../../Components/CustomUi/loadingPdf";
import { Render } from "../../../../../../Components/CustomUi/render";

//PROPS
interface Props {
    exibir_terreno: boolean;
    setExibir_terreno: React.Dispatch<React.SetStateAction<boolean>>;
    exibir_lista_talhoes: boolean;
    setExibir_lista_talhoes: React.Dispatch<React.SetStateAction<boolean>>;
    nome_safra_selecionada: string;
    resumirBook: boolean;
}

export const HeaderBook: React.FC<Props> = ({ exibir_terreno, setExibir_terreno, nome_safra_selecionada, setExibir_lista_talhoes, exibir_lista_talhoes, resumirBook }) => {

    const { nameCliente } = useAccess()

    //REF
    const btnPrint = useRef<ReactToPrint>()
    const controle_pdf = useRef<AbortController | null>(null);

    //STATES
    const [fake_loading, setFake_loading] = useState(false);
    const [gerando_pdf, setGerando_pdf] = useState(false);
    const [pagina_atual, setPagina_atual] = useState<number>(0);
    const [total_paginas, setTotal_paginas] = useState<number>(0);
    const [cancelando_pdf, setCancelando_pdf] = useState(false);

    //interrompe a geração caso o usuário saia da tela no meio do processo
    useEffect(() => {
        return () => {
            controle_pdf.current?.abort();
        }
    }, []);

    function fakeLoading() {
        setTimeout(() => {
            setFake_loading(false)
        }, 2000);
    }

    const nome_arquivo = `Book_fertilidade_agrupado__${nome_safra_selecionada}__cliente_${nameCliente}`;

    async function baixarPdf() {

        if (gerando_pdf) return;

        const controller = new AbortController();
        controle_pdf.current = controller;

        setGerando_pdf(true);
        setCancelando_pdf(false);
        setPagina_atual(0);
        setTotal_paginas(0);

        try {
            await gerarPdfDoBook({
                id_container: 'book_fertilidade_resumido',
                nome_arquivo: nome_arquivo,
                onTotalPaginas: setTotal_paginas,
                onProgresso: (pagina_atual) => setPagina_atual(pagina_atual),
                signal: controller.signal
            });

            successAlert('PDF gerado com sucesso!');
        }
        catch (error) {
            //cancelamento é uma ação do usuário, não uma falha
            if (error instanceof GeracaoCanceladaError) {
                infoAlert('Geração do PDF cancelada.');
            }
            else {
                errorAlert(error?.message ?? 'Não foi possível gerar o PDF.');
            }
        }
        finally {
            controle_pdf.current = null;
            setGerando_pdf(false);
            setCancelando_pdf(false);
        }
    }

    function cancelarPdf() {
        //o loop verifica o sinal entre as páginas, então o modal só fecha ao fim da atual
        setCancelando_pdf(true);
        controle_pdf.current?.abort();
    }

    return (
        <Action>

            <LoadingPdf
                open={gerando_pdf}
                pagina_atual={pagina_atual}
                total_paginas={total_paginas}
                cancelando={cancelando_pdf}
                onCancelar={cancelarPdf}
            />

            <Switcher
                isChecked={exibir_lista_talhoes}
                trigger={setExibir_lista_talhoes}
                label='Exibir lista de talhões'
            />

            <Switcher
                isChecked={exibir_terreno}
                trigger={setExibir_terreno}
                label='Exibir terreno'
            />
            {/* </Render> */}

            {/* <div className="Action__quality">
                <motion.button 
                    className="Action__quality__trigger"
                >
                    Qualidade melhorada
                </motion.button>
            </div> */}
            <ButtonCustom
                onClick={baixarPdf}
                icon={<FontAwesomeIcon icon={faFilePdf} />}
                loading={gerando_pdf}
                type="secondary"
            >
                Gerar pdf
            </ButtonCustom>

            <ReactToPrint
                ref={btnPrint}
                trigger={() => (
                    <ButtonCustom
                        onClick={() => { }}
                        icon={<FontAwesomeIcon icon={faPrint} />}
                        loading={fake_loading}
                    >
                        Imprimir
                    </ButtonCustom>
                )}
                // onBeforePrint={()=>{setFake_loading(true);fakeLoading()}}
                content={() => document.getElementById('book_fertilidade_resumido')}
                onBeforeGetContent={() => { setFake_loading(true); fakeLoading() }}
                documentTitle={nome_arquivo}
            />


        </Action >
    )
}